import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ExternalLink, Sparkles } from "lucide-react";
import { api } from "@/lib/api";

export const LinkedStudioSites = ({ projectId }) => {
  const [sites, setSites] = useState([]);
  useEffect(() => { api.get("/admin/studio/projects", { params: { client_project_id: projectId } }).then((r) => setSites(r.data)).catch(() => {}); }, [projectId]);
  if (!sites.length) return null;
  return (
    <div data-testid="project-linked-studio-sites" className="card-tech mb-8 rounded-2xl p-5">
      <p className="mb-3 flex items-center gap-2 text-sm font-semibold text-white"><Sparkles className="h-4 w-4 text-cyan-300" /> AI Studio site</p>
      <ul className="space-y-2">
        {sites.map((s) => (
          <li key={s.id} data-testid={`project-linked-site-${s.id}`} className="flex flex-col gap-1 text-sm sm:flex-row sm:items-center sm:justify-between">
            <Link to={`/admin/studio/${s.id}`} className="font-medium text-cyan-300 hover:text-white">{s.name}</Link>
            <span className="text-xs text-slate-400">
              {s.status}{s.current_version ? ` · v${s.current_version}` : ""}
              {s.published && <a href={`/sites/${s.published.slug}`} target="_blank" rel="noreferrer" className="ml-2 inline-flex items-center gap-1 text-emerald-300 hover:text-white">/sites/{s.published.slug} <ExternalLink className="h-3 w-3" /></a>}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};
